<template>
  <div class="pdp-no-product-data text-center pt-4 pb-4">
    Failed to load product data. <a href="#" @click.prevent="tryAgain">Try Again?</a>
  </div>
</template>
<script>
export default {
  name: 'PdpNoProductData',
  methods: {
    tryAgain() {
      this.$emit('try-again');
    },
  },
};
</script>
